// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import { array, number, string } from 'prop-types';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useContextSelector } from 'use-context-selector';

import { UserContext } from 'Contexts/UserContext';
import useNumberUtils from 'Hooks/useNumberUtils';

const StyledContainer = styled.div`
  text-align: right;
  margin: 4px 0 8px;

  p {
    font-weight: 700;
    color: #3A3A3A !important;
  }

  .listItem {
    padding: 4px;
    font-size: 14px;
  }

  .qbpQuantity {
    margin-right: 24px;
  }

  button {
    cursor: pointer;
    border: none;
    background: transparent;
    text-transform: lowercase;
    color: #1F59A2;
    height: auto !important;
    min-height: auto !important;
    display: inline-block;
    font-size: 14px;
    width: auto;
    margin: 0;
    padding: 0;
    min-width: 0;
  }
`;

const QuantityBasedPrice = props => {
  const {
    className,
    priceScales,
    visibleItems,
    currency: currencyProp,
  } = props;
  const { t } = useTranslation();
  const userData = useContextSelector(UserContext, ({ data }) => data);
  const currency = currencyProp || userData?.defaultCurrency;
  const { formatNumber } = useNumberUtils();
  const DEFAULT_ITEMS_TO_SHOW = 3;
  const initialItemsToShow = visibleItems !== undefined ? visibleItems : DEFAULT_ITEMS_TO_SHOW;
  const [open, setOpen] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(initialItemsToShow);

  useEffect(() => {
    if (open) {
      setItemsToShow(priceScales.length);
    } else {
      setItemsToShow(initialItemsToShow);
    }
  }, [open]);

  return (
    <StyledContainer className={ className }>
      <p>{ t('products.quantityBasedPrices') }</p>
      <div>
        {
          priceScales.slice(0, itemsToShow).map(item => (
            <div key={ item.quantityFrom } className="listItem">
              { item.quantityTo > 99 ? (
                <span className="qbpQuantity">{item.quantityFrom}+</span>
              ) : (
                <span className="qbpQuantity">{ `${ item.quantityFrom } - ${ item.quantityTo }` }:</span>
              ) }
              <span className="qbpPrice">
                { formatNumber(item.price, {
                  maximumFractionDigits: 2,
                  currency
                }) }
              </span>
            </div>
          ))
        }
      </div>
      { priceScales.length > initialItemsToShow && (
        <button
          type="button"
          onClick={ () => setOpen(!open) }
        >
          { open ? t('products.viewLess') : t('products.viewMore') }
        </button>
      )}
    </StyledContainer>
  );
};

QuantityBasedPrice.propTypes = {
  className: string,
  priceScales: array,
  visibleItems: number,
  currency: string,
};

QuantityBasedPrice.displayName = 'QuantityBasedPriceComponent';

export default QuantityBasedPrice;
